<template>
	<div id="rugl">
		<span style="float: left;margin: 16px 0 0 5px;">商品出库</span>
		<!--<div class="fflex ffbet">-->
		<!--<ul class="fflex headBox">-->
		<!--<li @click="jump('shanglei')">商品类型</li>-->
		<!--<li @click="jump('gongys')">出库人</li>-->
		<!--<li class="active">商品信息</li>-->
		<!--<li @click="jump('wuliu')">物流设置</li>-->
		<!--<li @click="jump('churukl')">出入库类型</li>-->
		<!--<li @click="jump('rizhi')">日志列表</li>-->
		<!--</ul>-->
		<!--<div class="sousuok">-->
		<!---->
		<!--</div>-->
		<!--</div>-->

		<div class="fflex ffend" style="margin: 10px 0;line-height: 32px;color: #999">
			<div>
				<el-date-picker style="width: 260px;margin-right: 10px" v-model="setime" size="small" :name="['time_s','time_e']"
				 type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
				<!--<span>出库人：</span>-->
				<!--<select name=""  class="xiala " v-model="supplier_id"  style="width: 120px;margin-right: 10px;margin-left: 5px" >-->
				<!--<option value="">请选择</option>-->
				<!--<option :value="su.id" v-for="(su,suindex) in suppliers" :key="suindex">{{su.supplier_name}}</option>-->

				<!--</select>-->
				<span>出库人：</span>
				<select name="" class="xiala " v-model="person" style="width: 120px;margin-right: 10px;margin-left: 5px">
					<option value="">请选择</option>
					<option :value="u.user_id" v-for="(u,uindex) in users" :key="uindex">{{u.username}}</option>

				</select>
				<el-button type="success" size="mini" style="margin-right: 10px" @click="chaxun">查询</el-button>
				<el-button type="success" round size="mini" class="purBtnsz" style="height: 28px;" @click="tianjrk">添加出库单</el-button>
			</div>




		</div>

		<div class="tableBox">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th>序号</th>
						<th>出库单号</th>
						<th>采购日期</th>
						<th>创建日期</th>
						<th>供货商</th>
						<th>出库金额</th>
						<th>业务类别</th>
						<th>出库人</th>

						<th>操作</th>


					</tr>
				</thead>
				<tbody>
					<tr v-for="(ta,taindex) in tabledata" :key="taindex">
						<td>{{taindex+1}}</td>
						<td>{{ta.order_num}}</td>
						<td>{{ta.date}}</td>
						<td>{{ta.create_time}} </td>
						<td>{{ta.supplier_name}} </td>

						<td>{{ta.sum_price}}</td>
						<td>{{ta.storage_name}} </td>
						<td>{{ta.person}}</td>


						<td>
							<span class="tablebtnBox">
								<div class="qianziBtn-mini" style="background: rgb(0, 204, 228);color: #fff" @click="chakan(ta.id)">查看</div>

								<!--<div class="shenziBtn-mini" @click="tan(3)" >修改</div>-->
								<div class="qianziBtn-mini" @click="delfn(ta.id)" style="    background: rgb(255, 121, 124);color: #fff">作废</div>
							</span>
						</td>

					</tr>

				</tbody>
			</table>

		</div>




		<div class="table-bottom">
			<div>
				<el-pagination @current-change="handleCurrentChange" :current-page="currentpage" :page-size="pageone" background
				 layout="prev, pager, next" :total="total">
				</el-pagination>
			</div>
		</div>

		<!--查看弹窗s-->
		<el-dialog class="tanchuang" title="查看信息" :visible.sync="ruglt" width="950px">

			<div style="height: 400px;overflow-y: scroll">
				<el-row>
					<el-col :span="12" class="marBo2">
						<span class="inputT">制单人：</span>
						<span class="inputT">{{order_info.user_name}}</span>

					</el-col>
					<el-col :span="12" class="marBo2">
						<div class="demo-input-suffix">
							<span class="inputT">采购日期:</span>

							<span class="inputT">{{order_info.date}}</span>
							<!--<el-date-picker-->
							<!--:disabled="dis"-->
							<!--style="width: 200px"-->
							<!--format="yyyy-MM-dd"-->
							<!--value-format="yyyy-MM-dd"-->
							<!--size="small"-->
							<!--v-model="order_info.date"-->
							<!--type="date"-->
							<!--placeholder="选择日期">-->
							<!--</el-date-picker>-->
						</div>

					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">出库人：</span>
						<span class="inputT">{{order_info.date}}</span>
						<!--<select name=""  class="xiala "  :disabled="dis">-->
						<!--<option value="">请选择</option>-->
						<!--<option :value="su.id" v-for="(su,suindex) in suppliers" :key="suindex">{{su.supplier_name}}</option>-->
						<!--</select>-->
					</el-col>


					<el-col :span="12" class="marBo2">
						<span class="inputT">出库人：</span>
						<!--<select name=""  class="xiala "  :disabled="dis">-->
						<!--<option value="">请选择</option>-->
						<!--<option :value="u.user_id" v-for="(u,uindex) in users" :key="uindex">{{u.username}}</option>-->
						<!--</select>-->
						<span class="inputT">{{order_info.person}}</span>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">业务类别：</span>
						<span class="inputT">{{order_info.order_status}}</span>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">货运公司：</span>
						<span class="inputT">{{order_info.express_name}}</span>
						<!--<select name=""  class="xiala "  :disabled="dis">-->
						<!--<option value="">请选择</option>-->
						<!--<option :value="ex.id" v-for="(ex,eindex) in express" :key="eindex">{{ex.express_name}}</option>-->


						<!--</select>-->
						<!--<el-input-->
						<!--style="width: 200px"-->
						<!--v-model="order_info.express_name"-->
						<!--:disabled="dis"-->
						<!--size="small"-->
						<!--&gt;-->
						<!--</el-input>-->

					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">货运费用：</span>
						<span class="inputT">{{order_info.express_price}}</span>
						<!--<el-input-->
						<!--style="width: 200px"-->

						<!--:disabled="dis"-->
						<!--size="small"-->
						<!--&gt;-->
						<!--</el-input>-->
					</el-col>
					<el-col :span="12" class="marBo2">
						<span class="inputT">货运单号：</span>
						<span class="inputT">{{order_info.express_num}}</span>
						<!--<el-input-->
						<!--style="width: 200px"-->

						<!--:disabled="dis"-->
						<!--size="small"-->
						<!--&gt;-->
						<!--</el-input>-->
					</el-col>


					<el-col :span="24" class="marBo2">
						<span class="inputT" style="padding-bottom: 10px;vertical-align: top"> 备注：</span>
						<p class="inputT">{{order_info.notes}}</p>
						<!--<el-input-->
						<!--style="width: 82%"-->
						<!--:disabled="dis"-->
						<!--type="textarea"-->
						<!--:autosize="{ minRows: 2}"-->

						<!--&gt;-->
						<!--</el-input>-->
					</el-col>

					<!--<el-col :span="24" v-if="zhuang==1" style="text-align: center;margin-bottom: 10px">-->
					<!--<el-button type="success" round size="mini" class="purBtnsz" @click="tianj">添加商品</el-button>-->
					<!--</el-col>-->
					<el-col :span="24">
						<div class="tableBox" style="overflow-x: scroll">
							<table class="table table-bordered">
								<thead>
									<tr>

										<th>商品编号</th>
										<th>商品名称</th>
										<th>图片</th>

										<th>规格</th>
										<th>单位</th>
										<th>数量</th>
<!--										<th>价格</th>-->

<!--										<th>合计</th>-->
										<th>备注</th>




									</tr>
								</thead>
								<tbody>
									<tr v-for="(ord,oindex) in order_goods" :key="oindex">

										<td>
											{{ord.good_num}}
										</td>
										<td>{{ord.good_name}}</td>
										<td><img style="width: 25px;height: 25px" :preview="oindex+1" :src="ord.imgpath" alt=""> </td>
										<td>{{ord.spec}}</td>
										<td>{{ord.unit}} </td>

										<td>{{ord.number}} </td>
<!--										<td>{{ord.price}} </td>-->
<!--										<td>{{ord.sumprice}}</td>-->
										<td>{{ord.good_notes}}</td>

									</tr>

								</tbody>
							</table>

						</div>
					</el-col>

				</el-row>
			</div>
		</el-dialog>
		<!--查看弹窗eeee-->

		<el-dialog class="tanchuang" title="添加出库单" :visible.sync="ruglt2" width="1000px">

			<form id="ruku" style="height: 450px;overflow-y: scroll" method='post' enctype="multipart/form-data">
				<input type="hidden" name="token" v-model="token">
				<el-row>
					<el-col :span="12" class="marBo2" style="height: 32px;line-height: 32px">
						<span class="inputT">制单人：</span>
						<span class="inputT">{{addmeg.user_name}}</span>

					</el-col>
					<el-col :span="12" class="marBo2">
						<div class="demo-input-suffix">
							<span class="inputT">采购日期:</span>
							<el-date-picker name="date" style="width: 200px" format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small"
							 v-model="addmeg.date" type="date" placeholder="选择日期">
							</el-date-picker>
						</div>

					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">出库人：</span>
						<select name="" class="xiala " name="person">
							<option value="">请选择</option>
							<option :value="u.user_id" v-for="(u,uindex) in addmeg.users" :key="uindex">{{u.username}}</option>
						</select>
						<!--<span class="inputT">{{order_info.person}}</span>-->
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">业务类别：</span>
						<select name="" class="xiala " name="order_status">
							<option value="">请选择</option>
							<option :value="sto.id" v-for="(sto,stoindex) in addmeg.storages" :key="stoindex">{{sto.name}}</option>
						</select>
					</el-col>


					<el-col :span="12" class="marBo2">
						<span class="inputT">货运公司：</span>
						<!--<span class="inputT">{{order_info.express_name}}</span>-->
						<select name="express_id" class="xiala ">
							<option value="">请选择</option>
							<option :value="ex.id" v-for="(ex,eindex) in addmeg.express" :key="eindex">{{ex.express_name}}</option>


						</select>
						<!--<el-input-->
						<!--style="width: 200px"-->
						<!--v-model="order_info.express_name"-->
						<!--:disabled="dis"-->
						<!--size="small"-->
						<!--&gt;-->
						<!--</el-input>-->

					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">货运费用：</span>
						<!--<span class="inputT">{{order_info.express_price}}</span>-->
						<el-input name="express_price" style="width: 200px" size="small">
						</el-input>
					</el-col>
					<el-col :span="12" class="marBo2">
						<span class="inputT">货运单号：</span>
						<el-input style="width: 200px" name="express_num" size="small">
						</el-input>

					</el-col>


					<el-col :span="24" class="marBo2">
						<span class="inputT" style="padding-bottom: 10px;vertical-align: top"> 备注：</span>

						<el-input style="width: 82%" type="textarea" :autosize="{ minRows: 2}" name="notes">
						</el-input>
					</el-col>

					<el-col :span="24" style="text-align: center;margin-bottom: 10px">
						<el-button type="success" round size="mini" class="purBtnsz" @click="tianjshangp">添加商品</el-button>
					</el-col>
					<el-col :span="24">
						<div class="tableBox" style="overflow-x: scroll">
							<table class="table table-bordered">
								<thead>
									<tr>

										<th>商品编号</th>
										<th>商品名称</th>
										<th>图片</th>

										<th>规格</th>
										<th>单位</th>
										<th>数量</th>
										<th>可用库存</th>
<!--										<th>价格</th>-->
<!--										<th>合计</th>-->

										<th>备注</th>
										<th>操作</th>




									</tr>
								</thead>
								<tbody>
									<tr v-for="(ord,oindex) in order_goods2" :key="oindex">
										<td>
											{{ord.good_num}}
											<input type="hidden" name="goods_id[]" v-model="ord.id">
										</td>
										<td>{{ord.good_name}}</td>
										<td><img style="width: 25px;height: 25px" :preview="oindex+1" :src="ord.imgpath" alt=""> </td>
										<td>{{ord.spec}}</td>
										<td>{{ord.unit}} </td>
										<td>
											<input name="number[]" @change="hejifn" type="number" style="width: 50px" v-model="ord.number">
										</td>
										<td>
											{{ord.stock}}
										</td>
<!--										<td>-->
<!--											<input type="number" @change="hejifn" name="price[]" style="width: 50px" v-model="ord.price">-->
<!--										</td>-->
<!--										<td ref="jiage">-->
<!--											{{(ord.number==undefined ? 0 : ord.number) * (ord.price==undefined ? 0 : ord.price)}}-->
<!--										</td>-->
										<td><input type="text" name="good_notes[]" v-model="ord.good_notes"></td>
										<td @click="deletefn(oindex)">删除</td>
									</tr>
									<tr v-if="order_goods2 == ''">
										<td colspan="11">暂无数据</td>
									</tr>
<!--									<tr>-->
<!--										<td colspan="8" style="text-align: left">合计</td>-->
<!--										<td><input type="hidden" name="sumprice" v-model="heji"> <span>{{heji}}</span></td>-->
<!--										<td colspan="2"></td>-->
<!--									</tr>-->
								</tbody>
							</table>
						</div>
					</el-col>
				</el-row>

				<div style="display: flex;justify-content: center;align-items: center;margin-top: 15px;margin-bottom: 15px">
					<el-button type="success" round size="mini" class="purBtnsz" style="height: 28px;" @click="quetj">确认添加</el-button>
				</div>
			</form>
		</el-dialog>

		<!--选择商品sss-->
		<el-dialog class="tanchuang" title="选择商品" :visible.sync="goodschecked" width="70%">

			<div style="height: 450px;overflow-y: scroll">
				<el-row>


					<el-col :span="7" class="marBo2">
						<span class="inputT" style="width: auto;padding-right: 10px">商品类别：</span>
						<!--<span class="inputT">{{order_info.express_price}}</span>-->
						<select name="" class="xiala" v-model="Ggtype" style="width: 100px" :disabled="dis">
							<option value="">请选择</option>
							<option :value="g.id" v-for="(g,gindex) in Ggood_types" :key="gindex">{{g.type_name}}</option>
						</select>

					</el-col>
					<!--<el-col :span="7" class="marBo2">-->
					<!--<span class="inputT" style="width: auto;padding-right: 10px">出库人：</span>-->
					<!--<select name="" v-model="Gsup" class="xiala" style="width: 100px" :disabled="dis">-->
					<!--<option value="">请选择</option>-->
					<!--<option :value="su.id" v-for="(su,suindex) in Gsuppliers" :key="suindex">{{su.supplier_name}}</option>-->
					<!--</select>-->

					<!--</el-col>-->

					<el-col :span="7" class="marBo2">
						<span class="inputT" style="width: auto;padding-right: 10px">商品名称：</span>
						<el-input v-model="Ggoodsname" style="width: 100px" placeholder="商品名称查询" size="small">
						</el-input>

					</el-col>
					<el-col :span="3" class="marBo2">
						<el-button type="success" size="mini" style="margin-right: 10px" @click="chaxun2">查询</el-button>
					</el-col>



					<el-col :span="24">
						<div class="tableBox" style="overflow-x: scroll">

							<el-table ref="multipleTable" :data="Gdata" tooltip-effect="dark" style="width: 100%" height="250"
							 @selection-change="handleSelectionChange">
								<el-table-column fixed type="selection" width="55">
								</el-table-column>
								<el-table-column label="商品编号" prop="good_num" width="150">
								</el-table-column>

								<el-table-column label="商品名称" prop="good_name">
								</el-table-column>
								<el-table-column label="图片">
									<template slot-scope="scope">

										<a :href="scope.row.imgpath"><img style="width: 26px;height: 26px" :src="scope.row.imgpath" alt=""></a>
									</template>
								</el-table-column>
								<el-table-column label="规格" prop="spec">
								</el-table-column>
								<el-table-column label="单位" prop="unit">
								</el-table-column>
								<el-table-column label="销售价格" prop="real_price">
								</el-table-column>
								<el-table-column label="采购价" prop="purchase_price">
								</el-table-column>
<!--								<el-table-column label="上次采购价" prop="prev_purprice" width="100">-->
<!--								</el-table-column>-->
								<el-table-column label="可用库存" prop="stock">
								</el-table-column>


							</el-table>


							<div class="table-bottom">
								<div>
									<el-pagination @current-change="Gchange" :current-page="Gcurrentpage" :page-size="Gonepage" background layout="prev, pager, next"
									 :total="Gtotal">
									</el-pagination>
								</div>
							</div>

						</div>
					</el-col>



				</el-row>
				<div style="display: flex;justify-content: center;align-items: center;margin-top: 15px;margin-bottom: 15px">
					<el-button type="success" round size="mini" class="purBtnsz" style="height: 28px;" @click="addchanp">添加</el-button>
				</div>
			</div>
		</el-dialog>
		<!--选择商品eee-->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				token: '',
				gyshang: '',
				currentpage: 1,
				pageone: 10,
				total: 100,
				ruglt: false,
				zhuang: '',
				Ttitle: '',
				dis: false,
				sgday: '',
				//            shangphone:''
				goodsleiop: [{
					value: '',
					label: '请选择'
				}, {
					value: '195',
					label: '非消耗品'
				}, {
					value: '196',
					label: '日常消耗品'
				}, {
					value: '197',
					label: '固定资产'
				}],
				goodslei: '',
				ylimg: 'https://saas.gymbaby.cn/static/qmsj/img/jinxiaocun/default2.jpg',
				imgbox: [],
				setime: '',
				time_s: '',
				time_e: '',
				supplier_id: '',
				person: '',
				pagetotal: 0,
				//                suppliers:'',
				users: '',
				tabledata: '',
				order_info: '',
				good_types: '',
				express: "",
				order_goods: '',
				order_goods2: '',
				ruglt2: false,
				addmeg: '',
				addSupplier: '',
				goodschecked: false,

				Ggood_types: '',
				Gdata: [],
				Gtotal: 0,
				Gonepage: 4,
				Gcurrentpage: 1,
				//                Gsuppliers:'',
				Ggtype: '',
				Gsup: '',
				Ggoodsname: '',
				multipleSelection: '',
				heji: 0

			};
		},
		//    computed:{
		//        heji:function () {
		//            let h=0;
		//            if(this.$refs.jiage){
		//                for(var i=0;i<this.$refs.jiage.length;i++){
		//                    h+=Number(this.$refs.jiage[i].innerHTML)
		//                }
		//            }else{
		//                return 0;
		//            }
		//
		//            return this.$refs.jiage;
		//
		//        }
		//    },
		methods: {
			hejifn: function() {
				let h = 0;
				for (var i = 0; i < this.$refs.jiage.length; i++) {
					h += Number(this.$refs.jiage[i].innerHTML)
				}
				this.heji = Number(h) || 0;
			},
			quetj: function() {
				let self = this;

				var art_form = new FormData($('#ruku')[0]);
				$.ajax({
					"type": "post",
					"url": process.env.apiUrl + "saas/JxcOrder/storeout",
					contentType: false,
					processData: false,
					"dataType": "json",
					"data": art_form,
					success: function(data) {
						if (data.status == 1) {

							self.$message({
								type: 'success',
								message: data.msg
							});
							// location.reload()
							self.ruglt2 = false;
							self.gonggong()
						} else {
							self.$message({
								type: 'error',
								message: data.msg
							});
						}

					}
				});
			},
			deletefn: function(i) {
				let self = this;

				self.order_goods2.splice(i, 1)
			},
			Gchange: function(i) {
				let self = this;

				self.Gcurrentpage = i;
				self.addgonggong()
			},
			addchanp: function() {
				let self = this;
				self.order_goods2 = [...self.order_goods2, ...self.multipleSelection]
				self.goodschecked = false;
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			chaxun2: function() {
				//          alert(11111)
				let self = this;
				self.addgonggong()
			},

			addgonggong: function() {
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + 'saas/JxcGoods/goodslist',
					dataType: 'json',
					data: {
						token: self.token,
						search: self.Ggoodsname,
						typeid: self.Ggtype,
						supplierid: self.Gsup,
						page: self.Gcurrentpage,
						pageone: 4
					},
					success: function(data) {

						self.Ggood_types = data.good_types;
						self.Gdata = data.data;
						self.Gtotal = Number(data.map.count)
						//                        self.Gsuppliers=data.storages
					}
				})

			},
			tianjshangp: function() {
				let self = this;
				//                if(!self.addSupplier){
				//                    self.$message({
				//                        type: 'error',
				//                        message: '请选择出库人!'
				//                    });
				//                    return false;
				//                }else{
				self.goodschecked = true

				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + 'saas/JxcGoods/goodslist',
					dataType: 'json',
					data: {
						token: self.token,
						pageone: 4,
						page: 1
					},
					success: function(data) {
						self.Ggood_types = data.good_types;
						self.Gdata = data.data;
						self.Gtotal = Number(data.map.count)
						//                            self.Gsuppliers=data.storages


					}
				})


				//                }




			},
			tianjrk: function() {
				let self = this;
				self.ruglt2 = true;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + 'saas/JxcOrder/addout',
					dataType: 'json',
					data: {
						token: self.token,
					},
					success: function(data) {
						self.addmeg = data
					}
				})




			},
			chakan: function(id) {
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + 'saas/JxcOrder/showout',
					dataType: 'json',
					data: {
						token: self.token,
						id: id
					},
					success: function(data) {
						self.ruglt = true;
						self.order_info = data.order_info
						self.order_goods = data.order_goods


					}
				})
			},
			upimg: function() {
				let self = this;
				$('#img_upload').click()


			},
			chaxun: function() {
				let self = this;
				self.currentpage = 1;
				self.gonggong();

			},
			fn: function(e) {
				//this.filebox.push(e.currentTarget.files);

				//ss

				this.ylimg = URL.createObjectURL(e.currentTarget.files[0])

			},
			tan: function(e, id) {
				let self = this;
				this.zhuang = e;
				if (this.zhuang == 1) {
					this.Ttitle = '添加商品'
					this.dis = false;

				} else if (this.zhuang == 2) {
					this.Ttitle = '查看商品'
					this.dis = true;

					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcOrder/showout',
						dataType: 'json',
						data: {
							token: self.token,
							id: id
						},
						success: function(data) {
							self.order_info = data.order_info
						}
					})
					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcGoods/goodslist',
						dataType: 'json',
						data: {
							token: self.token,
							id: id
						},
						success: function(data) {

							self.good_types = data.good_types


						}
					})

				} else {
					this.Ttitle = '修改商品'
					this.dis = false;
				}
				this.ruglt = true;
			},
			handleCurrentChange: function(i) {
				let self = this;
				self.currentpage = i;
				self.gonggong()
			},
			searchname: function() {
				alert(this.gyshang)
			},
			jump: function(e) {
				this.$router.push({
					'name': e
				})
			},
			tianj: function() {
				let self = this;

				//            if(/^[0-9]{1,4}-[0-9]{1,8}$/.test(self.shangphone) ){
				//                alert('格式正确！')
				//            }else{
				//                alert('格式不对！')
				//            }
			},
			delfn: function(id) {

				let self = this;
				this.$confirm('是否要作废此条记录?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					//这里请求ajax


					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcOrder/deleteout',
						dataType: 'json',
						data: {
							id: id,
							token: self.token,

						},
						success: function(data) {
							if (data.status == 1) {


								self.$message({
									type: 'success',
									message: data.msg
								});

								self.gonggong()

							} else {
								self.$message({
									type: 'error',
									message: data.msg
								});
							}



						}
					})







				}).catch(() => {
					//                this.$message({
					//                    type: 'info',
					//                    message: '已取消删除'
					//                });
				});


			},
			gonggong: function() {
				var self = this;
				let time_s = $('input[name="time_s"]').val()
				let time_e = $('input[name="time_e"]').val()
				self.time_s = time_s;
				self.time_e = time_e;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + 'saas/JxcOrder/out',
					dataType: 'json',
					data: {
						page: self.currentpage,
						pageone: self.pageone,
						token: self.token,
						time_s: self.time_s,
						time_e: self.time_e,
						supplier_id: self.supplier_id,
						person: self.person
					},
					success: function(data) {
						self.tabledata = data.data;
						self.total = Number(data.map.count)
						self.pagetotal = Number(data.map.pagetotal)
						//                        self.suppliers=data.storages;
						self.users = data.users;


					}
				})
			}


		},
		mounted: function() {
			var self = this;

			//        var testtoken= 'eyJuYW1lIjoiXHU2ZDRiXHU4YmQ1XHU5N2U5MiIsInVzZXJfaWQiOjM0ODIsImNlbnRyZV9pZCI6MjIzLCJyb2xlIjoiMiIsImdhbmd3ZWkiOiJcdTRlMmRcdTVmYzNcdTYwM2JcdTc2ZDEiLCJwaG9uZSI6IjE1MjY5MTg5OTgzIn0=|**|1528785491'
			//        self.$cookies.set("token",testtoken,"10000h")
			self.token = $.cookie('token');
			self.gonggong()

		}


	}
</script>

<style scoped>
	.xiala {
		width: 200px;
		height: 32px;
		line-height: 32px;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: 13px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

	}

	.yulantu {
		width: 100px;
		height: 100px;
		border-radius: 6px;
		margin-left: 10px;
	}

	ul {
		list-style: none;
	}

	#rugl p,
	label,
	ul {
		margin: 0;
		padding: 0;
	}

	.fflex {
		display: flex;
		display: -webkit-flex;
	}

	.ffbet {
		justify-content: space-between;
	}

	.ffend {
		justify-content: flex-end;
	}

	#rugl * {
		box-sizing: border-box;
	}

	#rugl {
		box-sizing: border-box;
		padding: 10px;
	}

	.headBox li {
		width: 75px;
		background: #8CBB77;
		height: 30px;
		line-height: 30px;
		margin-right: 8px;
		border-radius: 5px 5px 0 0;
		text-align: center;
		color: #fff;

	}

	.headBox li.active {
		background: #ecebfd;
		color: #8CBB77;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
	}

	.qzbtna {
		width: 75px;
		height: 30px;
		line-height: 30px;
		margin-right: 8px;
		border-radius: 5px 5px 0 0;
		text-align: center;
		background: #ecebfd;
		color: #8CBB77;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
	}

	.purBtnsz {
		background: #8CBB77 !important;
		height: 26px;
		border: none !important;
	}

	.marBo2 {
		margin-bottom: 10px;
	}

	.inputT {
		display: inline-block;
		width: 100px;

	}
</style>
<style>
	#rugl .el-table td,
	.el-table th {
		padding: 5px 0;
	}
</style>



// WEBPACK FOOTER //
// src/pages/jinxc/chukgl.vue